import type { DatasetZoomWrapperProps } from "./dataset-zoom.type";

import DatasetZoom from "./dataset-zoom.component";

const DatasetZoomWrapper = ({
  template,
  ...props
}: DatasetZoomWrapperProps) => {
  if (!template) return null;

  return <DatasetZoom {...props} template={template} />;
};

export default DatasetZoomWrapper;
